// src/app/layout/MainLayout.jsx
import { Outlet, useMatch } from "react-router-dom";
import { Box } from "@mui/material";
import SideBar from "./SideBar";
import TopBar from "./TopBar";

export default function MainLayout() {
  const isSalesImportWizard = Boolean(useMatch("/stock/operacion/ventas-importadas/importar"));

  return (
    <Box sx={{ height: "100dvh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <Box sx={{ p: 2, pb: 0 }}>
        <TopBar />
      </Box>

      <Box
        sx={{
          display: "flex",
          flex: 1,
          minHeight: 0,
          py: 0,
          pt: 0,
          gap: 0,
          overflow: "hidden",
        }}
      >
        <SideBar />

        <Box component="main" sx={{ flex: 1, minWidth: 0, minHeight: 0, display: "flex", flexDirection: "column", overflowY: isSalesImportWizard ? "hidden" : "auto", overflowX: "hidden" }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
